import { ReactElement } from 'react'
import { Box, Typography, useMediaQuery } from '@mui/material'
import Button from '@mui/material/Button'
import theme from 'src/theme'

interface Props {
  isBoundTree?: boolean
}
export default ({ isBoundTree }: Props): ReactElement => {
  let isPhone = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <>
      <Typography>
        By clicking register you agree to our Privacy Policy and Terms and
        Conditions linked below.
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: isPhone ? 'column' : 'row',
          justifyContent: 'center',
        }}
      >
        {isBoundTree && (
          <Button
            variant="outlined"
            color="primary"
            sx={{ mx: 1, mt: 4 }}
            href="/boundtree-trial"
          >
            Start a Free Trial
          </Button>
        )}
        <Button
          size="large"
          variant="outlined"
          color="primary"
          sx={{ mx: 1, mt: 4 }}
          href="https://www.foamfrat.com/privacy-policy"
          target="_blank"
        >
          Privacy Policy
        </Button>
        <Button
          size="large"
          variant="outlined"
          color="primary"
          sx={{ mx: 1, mt: 4 }}
          href="https://www.foamfrat.com/termsofservice"
          target="_blank"
        >
          Terms & Conditions
        </Button>
      </Box>
    </>
  )
}
